import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-info"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createStaticVNode("<g transform=\"translate(-5578.438 -370.404)\" class=\"\"><circle cx=\"5600.4\" cy=\"392.4\" r=\"10\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></circle><g transform=\"translate(5589.29 376.702)\" class=\"\"><line x1=\"11.4\" x2=\"11.4\" y1=\"20.1\" y2=\"14.6\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></line><line x1=\"11.4\" x2=\"11.4\" y1=\"11.4\" y2=\"11.4\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></line></g></g>", 1)
  ]), 16))
}
export default { render: render }